import { Component } from '@angular/core';
import { OrderDetailUpdateComponent } from '../../../components/admin/order-detail-update/order-detail-update.component';
import { HeaderComponent } from '../../../components/header/header.component';
import { FooterComponent } from '../../../components/footer/footer.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-administrator',
  standalone: true,
  imports: [OrderDetailUpdateComponent, HeaderComponent, FooterComponent, CommonModule],
  templateUrl: './administrator.component.html',
  styleUrl: './administrator.component.scss'
})
export class AdministratorComponent {
  isFilterInfo: boolean = false;
  index: number = 0;

  ngOnInit() {
    this.setOption(1);
  }

  setOption(ix: any) {
    // this.isFilterInfo = (ix == 2);
    this.index = ix;
  }
}
